import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useRouteMatch } from 'react-router';

export interface FlowsRouteParams {
  flowId?: string;
  tagId?: string;
}

interface RouteParams {
  flowId: string;
  tagId: string;
}

/**
 * Will only return a valid while inside a flows configure route
 */
export const useFlowProductsOverviewParams = (): FlowsRouteParams => {
  const { params } =
    useRouteMatch<RouteParams>(
      `${FLOWS_PRODUCTS_PATH}/:flowId/overview/:tagId?`,
    ) || {};

  return {
    flowId: params?.flowId,
    tagId: params?.tagId,
  };
};
